import {
  BsSkype,
  FaFacebookMessenger,
  SiMicrosoftoutlook,
} from 'react-icons/all';

interface IContactData {
  icon: any;
  userId: string;
  socialName: string;
  contactUrl: string;
}

export const contactData: IContactData[] = [
  {
    icon: <SiMicrosoftoutlook />,
    userId: 'nhanlnt@hotmail.com',
    socialName: 'Email',
    contactUrl: 'nhanlnt@hotmail.com',
  },
  {
    icon: <FaFacebookMessenger />,
    userId: 'thiennhan.lenguyen',
    socialName: 'Message',
    contactUrl: 'https://m.me/thiennhan.lenguyen',
  },
  {
    icon: <BsSkype />,
    userId: 'Jay',
    socialName: 'Skype',
    contactUrl: 'https://join.skype.com/invite/xNZCeIsOhGOV',
  },
];
